
import { reactive, onMounted } from 'vue'
import { useCart, useInformation }  from '@/store/store.ts';

export default {
  setup() {
    const items = reactive<string[]>([])
    const { addToCart } = useCart()
    const { setMessage } = useInformation()

    onMounted(() => {
      items.push('apple')
      items.push('banana')
      items.push('orange')
    })

    const getItem = (item:string) => {
      addToCart(item);
      setMessage(`You added ${item} in the cart`)
    }

    return {
      items,
      getItem
    }
  }
}
